import { Skeleton } from '@chakra-ui/react';

export const IndicatorButtonSkeleton = () => <Skeleton width="100px" height="32px" />;
